export enum DisclaimerTypes {
    DATA = "DATA",
    DEFAULT = "DEFAULT",
    PAY_FOR_CHOISE = "PAY_FOR_CHOISE",
    USE_RIGHT_DATA = "USE_RIGHT_DATA",
    EXTERNAL_RISK = "EXTERNAL_RISK",
    TERMS_CONDITIONS = "TERMS_CONDITIONS",
    PAGE_FOOTER = "PAGE_FOOTER"
}
